<template>
  <div class="m-3 fixed-top notification">
    <div
      v-for="notification in notifications"
      :key="notification.id"
      class="alert"
      @click="closeNotification(notification.id)"
      :class="{
        'alert-success': notification.type === 'success',
        'alert-info': notification.type === 'info',
        'alert-warning': notification.type === 'warning',
        'alert-danger': notification.type === 'error',
      }"
    >
      <strong v-if="notification.type === 'success'">Success!</strong>
      <strong v-else-if="notification.type === 'info'">Info!</strong>
      <strong v-else-if="notification.type === 'warning'">Warning!</strong>
      <strong v-else-if="notification.type === 'error'">Error!</strong>
      {{ notification.message }}
      <a class="float-right" aria-label="Close">
        <i
          v-if="notification.type === 'success'"
          class="bi bi-x text-success"
        ></i>
        <i
          v-else-if="notification.type === 'info'"
          class="bi bi-x text-info"
        ></i>
        <i
          v-else-if="notification.type === 'warning'"
          class="bi bi-x text-warning"
        ></i>
        <i
          v-else-if="notification.type === 'error'"
          class="bi bi-x text-danger"
        ></i>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "NotificationComponent",
  computed: {
    notifications() {
      return this.$store.getters["notification/getNotifications"];
    },
  },
  methods: {
    async closeNotification(id) {
      await this.$store.dispatch("notification/removeNotification", id);
    },
  },
};
</script>

<style scoped>
.alert:hover {
  cursor: pointer;
}
@media print {
  .notification {
    display: none;
  }
}
</style>
